module.exports = __webpack_public_path__ + "static/media/companies-icon-1.7145175f.svg";